<template>
    <v-dialog
        v-model="isOpen"
        max-width="600"
        persistent
    >
        <v-card class="multicart-modal">
            <v-card-title class="warning white--text d-flex align-center">
                <v-icon left color="white">mdi-cart-variant</v-icon>
                Warenkorbregal bestätigen
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeModal">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            
            <v-card-text class="pa-6">
                <div class="py-4">
                    <h2 class="text-h5 mb-3">Bist du sicher?</h2>
                    
                    <p class="text-body-1 grey--text text--darken-1 mb-4">
                        Möchtest du diese Bestellung wirklich ins Warenkorbregal verschieben?
                    </p>
                </div>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn @click="closeModal" text color="grey darken-1">
                    Abbrechen
                </v-btn>
                <v-btn @click="confirmAction" color="warning">
                    <v-icon left>mdi-check</v-icon>
                    Bestätigen
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'MulticartModal',
    data() {
        return {
            isOpen: true
        }
    },
    methods: {
        closeModal() {
            this.isOpen = false;
            this.$emit('close-modal');
        },
        confirmAction() {
            this.$emit('confirm-multicart');
            this.closeModal();
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.$emit('close-modal');
            }
        }
    }
}
</script>

<style scoped>
.multicart-modal {
    border-radius: 8px;
    overflow: hidden;
}

.v-btn {
    text-transform: none;
    font-weight: 500;
}

.v-alert {
    border-radius: 8px;
}

/* Responsive adjustments */
@media (max-width: 600px) {
    .multicart-modal {
        margin: 16px;
        border-radius: 8px;
    }
}
</style>